// API Configuration
// Centralized API endpoint configuration to avoid hardcoding URLs

const endpoint = import.meta.env.VITE_GRAPHQL_ENDPOINT;

if (!endpoint) {
  throw new Error(
    'VITE_GRAPHQL_ENDPOINT environment variable is required. Please set it in your .env file or environment.',
  );
}

export const GRAPHQL_ENDPOINT = endpoint;

/** REST API base URL derived from GraphQL endpoint (strip trailing /graphql). */
export const API_BASE_URL = endpoint.replace(/\/graphql\/?$/i, '');
